import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { push } from 'redux-router';
import validator from 'services/validator.js';
import constants from 'constants';
import actions from 'actions';
import axios from 'axios';

const {
  addLandingData,
  addAboutData,
  addRequestError,
  addErrorsSaga
} = actions;

const {
  LOAD_LANDING_DATA_SAGA,
  LOAD_ABOUT_DATA_SAGA,
  API_LANDING_DATA,
  API_ABOUT_DATA,
  CREATE_LANDING_DATA_SAGA,
  CREATE_ABOUT_DATA_SAGA
} = constants;


const apiLoadLandingData = () => {
  return axios.get(API_LANDING_DATA)
};

const apiCreateLandingData = (text) => {
  return axios.put(API_LANDING_DATA, {
    body: text
  })
}

const apiLoadAboutData = () => {
  return axios.get(API_ABOUT_DATA)
};

const apiCreateAboutData = (data) => {
  return axios.put(API_ABOUT_DATA, data)
}

function* loadLandingData() {
  try {
    const response = yield call(apiLoadLandingData);
    const data = response.data.landing.body;
    yield put(addLandingData(data));

  } catch (e) {
    yield put(addRequestError(e.response))
  }
}

function* loadAboutData() {
  try {
    const response = yield call(apiLoadAboutData);
    const data = response.data.about;
    yield put(addAboutData(data));

  } catch (e) {
    yield put(addRequestError(e.response))
  }
}

function* createLandingData({ data }) {
  const landingData = data;
  try {
    const response = yield call(apiCreateLandingData, landingData);
    toast.success('Data successfully saved!')
  } catch (e) {
    yield put(addErrorsSaga(CREATE_LANDING_DATA_SAGA, e.response))
  }
}

function* createAboutData({ data }) {
  const landingData = data;
  try {
    const response = yield call(apiCreateAboutData, landingData);
    toast.success('Data successfully saved!')
  } catch (e) {
    yield put(addErrorsSaga(CREATE_ABOUT_DATA_SAGA, e.response))
  }
}

function* __loadLandingData() {
  yield takeEvery(LOAD_LANDING_DATA_SAGA, loadLandingData)
}

function* __createLandingData() {
  yield takeEvery(CREATE_LANDING_DATA_SAGA, createLandingData)
}

function* __loadAboutData() {
  yield takeEvery(LOAD_ABOUT_DATA_SAGA, loadAboutData)
}

function* __createAboutData() {
  yield takeEvery(CREATE_ABOUT_DATA_SAGA, createAboutData)
}

export {
  __loadLandingData,
  __createLandingData,
  __loadAboutData,
  __createAboutData
};



// WEBPACK FOOTER //
// ./src/sagas/admin/landing.js